export enum CourseEvaluationState {
  inProcess = 0,
  approved = 1,
  failed = 2,
}
